<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'短信管理'}]" :title="'短信管理'"/> -->
            <!-- 主体 -->
            <div class="box">
                <!-- 剩余短信 -->
                <div class="residue">	
                    <p>短信余量：{{total}} 条</p>
                    <a href="https://dysms.console.aliyun.com/dysms.htm#/overview" target="_blank" rel="noopener noreferrer">
						<el-button type="primary">进入短信管理平台</el-button></a>
                </div>
                <!-- 设置 -->
                <el-card class="basic box_card mt16" shadow="never">
                    <div class="title" slot="header">短信通知设置<span>勾选后表示该项审核结果将发送通知</span></div>
                    <div class="setting">
                    <div class="checkbox">
                        <el-checkbox-group v-model="checkList" v-for="index of checkListChild.length" :key="index">
                            <el-checkbox v-for="(item,i) in checkListChild[index-1]" :key="i" :label="item.id">{{item.title}}</el-checkbox> 
                            
                        </el-checkbox-group>
                    </div>
                </div>
                <!-- 提交 -->
                <div class="submit">
                    <el-button type="primary" size="small" @click="submit"
					v-if="authorities.indexOf('sys:permission:background:sms:config:list:button:save')!=-1"
					>保存</el-button>
                </div>
                </el-card>
                
                
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import { API } from '@/axios/config.js'

export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            total:3520,//剩余短信
            checkList:[],//通知设置数组
            checkListChild:[]
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            this.$axiosz.get(`${API.UploadsService}/backstage/smsConfig`).then(res=>{
            if(res.code == 200){
                this.checkListChild = [[],[],[],[],[],[],[],[],[],[],[]]
                this.checkList = []
                res.data.map(val=>{
                    if(val.title.indexOf('用户认证审核') != -1){
                        this.checkListChild[0].push(val)
                    }else if(val.title.indexOf('债权融资发布审核') != -1){
                        this.checkListChild[1].push(val)
                    }else if(val.title.indexOf('债权融资申请审核') != -1){
                        this.checkListChild[2].push(val)
                    }else if(val.title.indexOf('融资租赁申请审核') != -1){
                        this.checkListChild[3].push(val)
                    }else if(val.title.indexOf('股权融资') != -1){
                        this.checkListChild[4].push(val)
                    }else if(val.title.indexOf('申请担保审核') != -1){
                        this.checkListChild[5].push(val)
                    }else if(val.title.indexOf('孵化器发布审核') != -1){
                        this.checkListChild[6].push(val)
                    }else if(val.title.indexOf('申请入驻孵化器审核') != -1){
                        this.checkListChild[7].push(val)
                    }else if(val.title.indexOf('政策资讯发布审核') != -1){
                        this.checkListChild[8].push(val)
                    }else if(val.title.indexOf('政策申报发布审核') != -1){
                        this.checkListChild[9].push(val)
                    }else if(val.title.indexOf('申请政策申报审核') != -1){
                        this.checkListChild[10].push(val)
                    }
                    if(val.send){
                        this.checkList.push(val.id)
                    }
                })
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
                
            })
        },
        //保存
        submit:function(){
            let parme = [];
            this.checkListChild.forEach(m => {
                m.forEach(n => {
                    let isTrue = false;
                    this.checkList.forEach(j => {
                        if(j == n.id){
                          isTrue = true;
                        }
                    })
                    parme.push({id:n.id,send:isTrue})
                })
            })
            this.checkList.map(val=>{
                parme.push({
                    id:val,
                    send:true
                })
            })
            this.$axioszBody.put(`${API.UploadsService}/backstage/smsConfig`,parme).then(res=>{
                if(res.code == 200){
                    this.init()
                    this.$message({
                        type: 'success',
                        message: '保存成功!'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        &_card{
      border:none;
      .title{
                color: #262626;
                font-size: 22px;
                font-weight: 400;
                font-size: 16px;
                span{
                    font-size: 14px;
                    margin-left: 9px;
                }
            }
            .checkbox{
                // margin-top: 20px;
                /deep/ .el-checkbox-group{
                    margin-bottom: 30px;
                }
            }
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
        .residue{
            width: 100%;
            height: 200px;
            background: #fff;
            text-align: center;
            padding-top: 24px;
            box-sizing: border-box;
            p{
                color: #515151;
                font-size: 26px;
                font-weight: 400;
                margin-bottom: 30px;
            }
        }
        .setting{
           // padding: 20px;
            // margin-top: 20px;
            
        }
        .submit{
            margin: 20px 0 0;
            text-align: left;
           
        }
    }
}
.main{
  background: transparent !important;
  padding: 0 !important;
}
</style>